import { render, staticRenderFns } from "./singleSalary.vue?vue&type=template&id=0b4c8b70&scoped=true&"
import script from "./singleSalary.vue?vue&type=script&lang=js&"
export * from "./singleSalary.vue?vue&type=script&lang=js&"
import style0 from "./singleSalary.vue?vue&type=style&index=0&id=0b4c8b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c8b70",
  null
  
)

export default component.exports